var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-border-b tw-cursor-pointer tw-relative",style:({
    borderColor: _setup.hover || _vm.isOpen ? 'white' : _vm.borderColorProp,
    '--tw-border-opacity': _vm.isOpen ? '1' : 'initial',
  }),on:{"mouseover":function($event){_setup.hover = true},"mouseleave":function($event){_setup.hover = false}}},[_c('i',{staticClass:"tw-text-xl tw-text-white",class:_vm.icon}),(_vm.notificationNumber !== 0)?_c('div',{staticClass:"tw-absolute tw-bg-white tw-w-2 tw-h-2 tw-rounded-full tw-font-robotoBold tw--top-1 tw-left-0"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }